import Login from './views/Login'
//import Dashboard from './views/Dashboard'
//import DashboardAdmin from './views/Admin/DashboardAdmin'
//import ResetPassword from './views/ResetPassword'

// Dealer facing
//import HelpCenter from './views/HelpCenter'
//import HelpCenterHome from './views/HelpCenterHome'
//import Articles from './views/Articles'
//import ArticlesHome from './views/ArticlesHome'
//import ArticlesDetail from './views/ArticlesDetail'
//import SupportTicketsHome from './views/SupportTicketsHome'
//import SupportTicketsDetail from './views/SupportTicketsDetail'
//import UserPermissions from './views/UserPermissions'
//import TermsOfUse from './views/TermsOfUse'
//import ClientProfile from './views/ClientProfile'

// Admin facing
//import Admin from './views/Admin/Admin'
//import ArticlesAdmin from './views/Admin/HelpCenterAdmin/ArticlesAdmin'
//import ArticlesAdminHome from './views/Admin/HelpCenterAdmin/ArticlesAdminHome'
//import ArticlesAdminDetail from './views/Admin/HelpCenterAdmin/ArticlesAdminDetail'
//import SystemAlerts from './views/Admin/SystemAlerts'
//import APIPolicies from './views/Admin/APIPolicies'
//import DealerMap from './views/Admin/DealerMap'
//import Clients from './views/Admin/Clients'
//import FeatureRequests from './views/Admin/FeatureRequests'

//import MenusAdmin from './views/MenusAdmin'

const DashboardRoutes = [
    {
        path: '/',
        // route level code-splitting
        // this generates a separate chunk (dashboard.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "dashboard-module" */ './DashboardModule.vue'),
        children: [
            {
                path: '', name: 'Dashboard', component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue')
            },
            { path: 'help-center', component: () => import(/* webpackChunkName: "help-center" */ './views/HelpCenter.vue'), props: true,
    			children: [
        				{
        					path: '', name: 'Help Center', component: () => import(/* webpackChunkName: "help-center-home" */ './views/HelpCenterHome.vue')
        				},
        				{
        					path: 'articles', component: () => import(/* webpackChunkName: "articles" */ './views/Articles.vue'), props: true, children: [
        						{
        							path: '', name: 'Help Center Articles Home', component: () => import(/* webpackChunkName: "articles-home" */ './views/ArticlesHome.vue'), props: true
        						},
        						{
        							path: ':kb_item_id', name: 'Help Center Articles Detail', component: () => import(/* webpackChunkName: "articles-detail" */ './views/ArticlesDetail.vue'), props: true
        						}
        					]
        				},
        				{
        					path: 'support-tickets', redirect: 'support-tickets/1'
        				},
        				{
        					path: 'support-tickets/:page', name: "Support Tickets Home", component: () => import(/* webpackChunkName: "support-tickets" */ './views/SupportTicketsHome.vue'), props: true
        				},
        				{
        					path: 'support-tickets-detail/:support_ticket_id', name: "Support Tickets Detail", component: () => import(/* webpackChunkName: "support-tickets-detail" */ './views/SupportTicketsDetail.vue'), props: true
        				}
        		]
    		},
            { path: 'admin', component: () => import(/* webpackChunkName: "admin" */ './views/Admin/Admin.vue'), props: true, children: [
                    { path: '', name: 'Admin Dashboard', component: () => import(/* webpackChunkName: "dashboard-admin" */ './views/Admin/DashboardAdmin.vue') },
                    { path: 'system-alerts', name: 'System Alerts', component: () => import(/* webpackChunkName: "system-alerts" */ './views/Admin/SystemAlerts.vue') },
                    { path: 'api-policies', name: 'API Policies', component: () => import(/* webpackChunkName: "api-policies" */ './views/Admin/APIPolicies.vue') },
                    { path: 'menus', name: 'Menus Admin', component: () => import(/* webpackChunkName: "menus-admin" */ './views/MenusAdmin.vue') },
    				{
    					path: 'articles', component: () => import(/* webpackChunkName: "articles-admin" */ './views/Admin/HelpCenterAdmin/ArticlesAdmin.vue'), props: true, children: [
    						{ path: '', name: 'Articles Home', component: () => import(/* webpackChunkName: "articles-admin-home" */ './views/Admin/HelpCenterAdmin/ArticlesAdminHome.vue'), props: true },
    						{ path: ':kb_item_id', name: 'Articles Detail', component: () => import(/* webpackChunkName: "articles-admin-detail" */ './views/Admin/HelpCenterAdmin/ArticlesAdminDetail.vue'), props: true }
    					]
    				},
                    {
                        path: 'clients', name: 'Clients', component: () => import(/* webpackChunkName: "clients" */ './views/Admin/Clients.vue'), props: true, children: [
                            { path: 'client-type/:client_type_id', name: 'Client Type', props: true },
                            { path: 'client-type/:client_type_id/client/:client_id', name: 'Client Type Detail', props: true },
                            { path: 'client/:client_id', name: 'Client Detail', props: true }
                        ]
                    },
				    { path: 'dealer-map', name: 'Dealer Map', component: () => import(/* webpackChunkName: "dealer-map" */ './views/Admin/DealerMap.vue') },
		            { path: 'feature-requests', name: 'Feature Requests', component: () => import(/* webpackChunkName: "feature-requests" */ './views/Admin/FeatureRequests.vue') },
		            { path: 'client-domains', name: 'Client Domains', component: () => import(/* webpackChunkName: "client-domains" */ './views/Admin/ClientDomains.vue') }
    			]
    		},
            {
                path: 'login', name: 'Login', component: Login
            },
            {
                path: 'reset-password', name: 'Reset Password', component: () => import(/* webpackChunkName: "reset-password" */ './views/ResetPassword.vue')
            },
            {
                path: 'users', name: 'Users', component: () => import(/* webpackChunkName: "users-admin" */ './views/Users.vue'), props: true, children: [
                    { path: 'profile', name: 'Your Profile' },
                    { path: 'detail/:user_id', name: 'User Detail' },
                    { path: 'user-type-group/:user_type_group', name: 'User Type Group', props: true },
                    { path: 'user-type-group/:user_type_group/user/:user_id', name: 'User Type Group User', props: true },
                    { path: 'user-type-group/:user_type_group/user-type/:user_type_id', name: 'User Type Group Types', props: true },
                    { path: 'user-type-group/:user_type_group/user-type/:user_type_id/user/:user_id', name: 'User Type Group Type User', props: true }
                ]
            },
			{
				path: 'user-permissions', name: 'User Permissions', component: () => import(/* webpackChunkName: "user-permissions" */ './views/UserPermissions')
			},
			{
				path: 'user-permissions/:user_id', name: 'User Permissions Detail', component: () => import(/* webpackChunkName: "user-permissions" */ './views/UserPermissions'), props: true
			},
			{
				path: 'merchant-settings', name: 'Merchant Settings', component: () => import(/* webpackChunkName: "merchant-settings" */ './views/MerchantSettings')
			},
			{
				path: 'terms-of-use', name: 'Terms of Use', component: () => import(/* webpackChunkName: "terms-of-use" */ './views/TermsOfUse')
			},
			{
				path: 'profile', name: 'Store Profile', component: () => import(/* webpackChunkName: "profile" */ './views/ClientProfile')
			},
			{
				path: 'account-payments', name: 'Account Payments', component: () => import(/* webpackChunkName: "account-payments" */ './views/AccountPayments')
			},
            {
                path: 'legacy/:iframe_src', name: 'Legacy', props: true, component: () => import(/* webpackChunkName: "legacay" */ './views/Legacy.vue')
            }

        ]
    }
]

export default DashboardRoutes
